__turbopack_context__.v({
  "cardList": "LeaderboardList-module__xdbQXq__cardList",
  "desktopControlsRow": "LeaderboardList-module__xdbQXq__desktopControlsRow",
  "listSection": "LeaderboardList-module__xdbQXq__listSection",
  "mobileControls": "LeaderboardList-module__xdbQXq__mobileControls",
  "toggleSlot": "LeaderboardList-module__xdbQXq__toggleSlot",
  "unitDesktop": "LeaderboardList-module__xdbQXq__unitDesktop",
  "unitMobile": "LeaderboardList-module__xdbQXq__unitMobile",
});
